var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table_actions"},[_c('call-tooltip',{attrs:{"placement":"top","content":"Info"}},[_c('call-button',{attrs:{"outlet":"","type":"success","round":"","not-border":"","icon":_vm.dataReadingIcon},on:{"click":function($event){return _vm.clickAction('update')}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }